import { FlowPage, PoweredByMonthio } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'

import type { FlowStepData } from '../../../pages/LandingPage/flowStepUtils'

import { ClientLogoHeader } from './ClientLogoHeader'
import { FlowSteps } from './FlowSteps'
import { IntroductionHeaderContainer } from './landingPage.styled'

interface AccessibleLandingPageContentProps {
	logoSrc?: string
	clientName: string
	flowSteps: FlowStepData[]
}
export const AccessibleLandingPageContent = ({
	logoSrc,
	clientName,
	flowSteps,
}: AccessibleLandingPageContentProps) => {
	const { t } = useTranslation()
	return (
		<>
			{logoSrc ? (
				<ClientLogoHeader logoSrc={logoSrc} clientName={clientName} />
			) : null}
			<IntroductionHeaderContainer>
				<FlowPage.Header
					title={t('landingPage-title')}
					description={t('landingPage-subtitle', { clientName })}
				/>
			</IntroductionHeaderContainer>
			<FlowSteps flowSteps={flowSteps} clientName={clientName} />
			<PoweredByMonthio />
		</>
	)
}
